import axios from 'axios';

const ROOT = 'api/v1/finance/studies';

const FinTriggerApi = {
  getEncounterTriggers(studyId) {
    //regular and unexpected
    return axios.get(`${ROOT}/${studyId}/triggers/encounters`);
  },

  getItemGroupTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/item-groups`);
  },

  getItemGroupFieldsTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/item-groups/fields`);
  },

  getUnexpectedItemGroupsTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/unexpected-item-groups`);
  },

  getEncounterItemGroupTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/encounter-item-groups`);
  },

  getSituationalItemGroupTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/situational-item-groups`);
  },

  getEncounterItemGroupFieldsTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/encounter-item-group-fields`);
  },

  getUnexpectedItemGroupFieldsTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/unexpected-item-group-fields`);
  },

  getSituationalItemGroupFieldsTriggers(studyId) {
    return axios.get(`${ROOT}/${studyId}/triggers/situational-item-group-fields`);
  }
};

export default FinTriggerApi;
